import { HttpFileServer } from '@application/http_file_server.service';

export interface FileIdentity {
	id: string;
	uploadUrl: string;
	downloadUrl: string;
	deleteUrl: string;
}

export class IdentityResolver {
	private identity: FileIdentity | null = null;
	private isCancelled = false;

	constructor(private readonly httpFileServer: HttpFileServer) {
		// Empty
	}

	public reset(): void {
		this.isCancelled = true;
		this.identity = null;
	}

	public getIdentity(): FileIdentity | null {
		return this.identity;
	}

	public async unwrapIdentity(endpoint: string, fileName: string, fileSize: number, fileType: string): Promise<FileIdentity> {
		if (this.identity != null) {
			return this.identity;
		}

		// This request should be cancellable from backend.
		const identity = await this.httpFileServer.identity(endpoint, fileName, fileSize, fileType);

		if (this.isCancelled) {
			// TODO: DEV-13650 expose a type of error from @visiba/http matching this.
			throw {
				__CANCEL__: true,
			};
		}

		this.identity = {
			id: identity.Id,
			uploadUrl: identity.UploadUrl,
			downloadUrl: identity.DownloadUrl,
			deleteUrl: identity.DeleteUrl,
		};

		return this.identity;
	}
}
